import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.span`
  margin-right: 4px;
  border-radius: 2px;
  background: #4182c3;
  color: #fff;
  padding: 2px 4px;
  font-size: 12px;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
`

export const Badge = ({ badgeText = 'Reklam' }) => <Wrapper>{badgeText}</Wrapper>

Badge.propTypes = {
  badgeText: PropTypes.string,
}

export default Badge
